import { useMemo } from "react";
import useGetTasksBatch from "../../Tasks/hooks/useGetTasksBatch";
import useGetTransitions from "./useGetTransitions";
export const useGetTransitionsDto = (authConfig, queryParams) => {
    const transitionsQuery = useGetTransitions(queryParams, authConfig);
    const taskIds = useMemo(() => {
        const transitions = transitionsQuery.data?.advisorTransitions ?? [];
        return transitions.map((transition) => transition.taskId);
    }, [transitionsQuery.data?.advisorTransitions]);
    const tasksQuery = useGetTasksBatch({ taskIds }, authConfig);
    const transitionsDto = useMemo(() => {
        const transitions = transitionsQuery.data?.advisorTransitions ?? [];
        if (tasksQuery.data?.values === undefined) {
            return [];
        }
        const taskMap = new Map(tasksQuery.data.values.map((task) => [task.id, task]));
        return transitions.map((transition) => {
            const task = taskMap.get(transition.taskId);
            return {
                ...transition,
                task: task,
            };
        });
    }, [transitionsQuery.data?.advisorTransitions, tasksQuery.data?.values]);
    if (transitionsQuery.isLoading || tasksQuery.isLoading) {
        return { data: undefined, isLoading: true, hasError: false };
    }
    if (transitionsQuery.hasError) {
        return {
            data: undefined,
            isLoading: false,
            hasError: true,
            error: transitionsQuery.error,
        };
    }
    if (tasksQuery.hasError) {
        return {
            data: undefined,
            isLoading: false,
            hasError: true,
            error: tasksQuery.error,
        };
    }
    const pagination = transitionsQuery.data?.pagination;
    return {
        data: {
            advisorTransitions: transitionsDto,
            pagination,
        },
        isLoading: false,
        hasError: false,
    };
};
//# sourceMappingURL=useGetTransitionsDto.js.map